import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function SpontaneousApplicationsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_1582)">
        <path
          d="M41.3507 0.415584C40.9351 0.207792 40.5195 0 40.1039 0C39.6883 0 39.0649 0.207792 38.6494 0.415584C29.0909 8.1039 0 30.7532 0 30.7532V76.2597H80V30.7532C80 30.7532 51.1169 8.1039 41.3507 0.415584Z"
          fill="#00416B"
        />
        <path
          d="M59.2207 10.1818H13.0908C11.2207 10.1818 9.76611 11.4286 9.76611 13.0909V77.9221H70.2336V21.1948C65.87 16.8312 63.5843 14.5455 59.2207 10.1818Z"
          fill="#EAEEF9"
        />
        <path
          d="M59.2207 10.1818L70.2337 21.1948H61.0908C60.2597 21.1948 59.4285 20.3636 59.4285 19.5325V10.1818H59.2207Z"
          fill="#00416B"
        />
        <path
          d="M40.1037 40.1039C31.1686 40.1039 23.6881 46.7533 22.6492 55.4805C22.4414 56.7273 23.4803 57.7662 24.7271 57.7662H55.6881C56.9349 57.7662 57.7661 56.7273 57.7661 55.4805C56.3115 46.7533 49.0388 40.1039 40.1037 40.1039Z"
          fill="#00416B"
        />
        <path
          d="M53.6102 30.5454C53.6102 38.026 47.5842 44.0519 40.1037 44.0519C32.6231 44.0519 26.5972 38.026 26.5972 30.5454C26.5972 23.0649 32.6231 17.039 40.1037 17.039C47.5842 17.039 53.6102 23.0649 53.6102 30.5454Z"
          fill="#EAEEF9"
        />
        <path
          d="M49.4548 30.5455C49.4548 35.7403 45.2989 40.1039 39.8963 40.1039C34.7015 40.1039 30.3379 35.9481 30.3379 30.5455C30.3379 25.3506 34.4937 20.987 39.8963 20.987C45.2989 20.987 49.4548 25.3506 49.4548 30.5455Z"
          fill="#00416B"
        />
        <path
          d="M80 30.7533V77.7143C80 78.961 78.961 80 77.7143 80H16L80 30.7533Z"
          fill="#00C4B3"
        />
        <path
          d="M0 30.7533V77.7143C0 78.961 1.03896 80 2.28571 80H64L0 30.7533Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_1582">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
